import React, { useState } from 'react'

import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

import { LabelButton } from 'components/Form'
import CalendarPicker from 'components/CalendarPicker'
let open = true
/**
 * It renders a label button that opens a calendar picker modal
 * @param props - {}
 * @param {string} label label text
 * @param {string} name label field name
 * @param {string} text label value or format
 * @param {object} search
 * @param {string} [className]
 * @param {number} idx index to save
 * @param {Function} handleOnChange change values
 * @param {boolean} multipleSelection
 * @returns {string, string} date, field
 * @returns A component that renders a calendar picker
 */
const CalendarField = (props) => {
  const [isOpen, setIsOpen] = useState(false)
  const [details, setDetails] = useState()

  const { imageUrl='calendar-primary.svg', label, subtitle='', name, valueFilters, text, className='', handleOnChange, isClear = false } = props

  const onClick = (field, index) =>{
    if(open){
      setIsOpen(!isOpen)
      setDetails({ field, value:valueFilters[field], index })
    }
  }

  const onClickClear = (field) =>{
    open = false
    handleOnChange(['', ''], field)
    setTimeout(() => {
      open = true
    }, 1000)
  }

  return (
    <div>
      <LabelButton
        label={label}
        text={text}
        imageUrl={getStaticImage(`/icons/orange-brand/${imageUrl}`)}
        imageClear={getStaticImage(`/icons/orange-brand/icon-close.svg`)}
        isClear={isClear}
        onClick={()=>onClick(name)}
        onClickClear={()=>onClickClear(name)}
        className={`label-button-filter ${className}`}
      />
      {isOpen && (
        <CalendarPicker
          mode='modal'
          initialValues={details.value}
          onChange={(value) => {
            if (Array.isArray(value) && value?.length) {
              const aValue = value
              if(value.length === 1) aValue.push('')
              handleOnChange(aValue, details.field)
            }
          }}
          modalOptions={{
            isOpen: isOpen,
            toggle: onClick,
            header: {
              title: label,
              subtitle: lang(subtitle || 'filters_subtitle_day')
            },
            buttons: true
          }}
          rangeSelection
          classNameCalendar='filter_calendar_range_date'
        />
      )}
    </div>
  )
}

export default CalendarField